
  <template>
      <div class="col-lg-12">
        <div class="main-card mb-3 card">
          <div class="card-body">
            <h5 class="card-title">아이디주문
            </h5>
            <div class="sub_title">주문관리->아이디주문</div>

            <div class="input-group" style="width:50%;display:none;">
              <span class="input-group-text" id="basic-addon1"><i class="bi bi-search"></i></span>
              <input type="text" class="form-control" placeholder="아이디, 이메일, 이름으로 검색하세요" aria-describedby="basic-addon1">
            </div>
            <div class="col-lg-6 offset-lg-3 search_box">

              <table class="table">

                <tr>
                  <td>
                    선택검색
                  </td>
                  <td>
                    <div class="input-group mb-12">
                      <div class="input-group-prepend">
                        <select class="custom-select flex_center" id="inputGroupSelect01">
                          <option selected>소속구분</option>
                          <option value="1">사용</option>
                          <option value="2">미사용</option>
                        </select>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="input-group mb-12">
                      <div class="input-group-prepend">
                        <select class="custom-select flex_center" id="inputGroupSelect01">
                          <option selected>캠퍼스 선택</option>
                          <option value="1">사용</option>
                          <option value="2">미사용</option>
                        </select>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="input-group mb-12">
                      <div class="input-group-prepend">
                        <select class="custom-select flex_center" id="inputGroupSelect01">
                          <option selected>타임 선택</option>
                          <option value="1">사용</option>
                          <option value="2">미사용</option>
                        </select>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>

                  </td>
                  <td>
                    <div class="input-group mb-12">
                      <div class="input-group-prepend">
                        <select class="custom-select flex_center" id="inputGroupSelect01">
                          <option selected>기간</option>
                          <option value="1"></option>
                          <option value="2"></option>
                        </select>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="input-group mb-12">
                      <div class="input-group-prepend">
                        <select class="custom-select flex_center" id="inputGroupSelect01">
                          <option selected>결제방법</option>
                          <option value="1">카드결제</option>
                          <option value="2">계좌이체</option>
                        </select>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="input-group mb-12">
                      <div class="input-group-prepend">
                        <select class="custom-select flex_center" id="inputGroupSelect01">
                          <option selected>상태</option>
                          <option value="1">사용</option>
                          <option value="2">미사용</option>
                        </select>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    날짜검색
                  </td>
                  <td>
                    <div class="input-group mb-12">
                      <div class="input-group-prepend">
                        <select class="custom-select flex_center" id="inputGroupSelect01">
                          <option selected>관리구분</option>
                          <option value="1">사용</option>
                          <option value="2">미사용</option>
                        </select>
                      </div>
                    </div>
                  </td>
                  <td colspan="2">
                    <div class="input-group mb-12">
                      <div class="input-group-prepend">
                        <input Type="date" /> ~ <input Type="date" />
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>
                    키워드검색
                  </td>
                  <td>
                    <div class="input-group mb-12">
                      <div class="input-group-prepend">
                        <select class="custom-select flex_center" id="inputGroupSelect01">
                          <option selected>검색값 선택</option>
                          <option value="1">상품명</option>
                          <option value="2">판매기간</option>
                        </select>
                      </div>
                    </div>
                  </td>
                  <td colspan="2">
                    <div class="input-group mb-12">
                      <div class="input-group-prepend">
                        <input type="text" class="input_text" />
                      </div>
                    </div>
                  </td>

                </tr>
              </table>
              <div class="flex_center">
              <button class="btn btn-secondary ">조회</button>
              <button class="btn btn-danger" data-toggle="modal" data-target=".bd-example-modal-lg">신규등록</button>
              <button class="btn btn-success ">엑셀저장</button>
              </div>
            </div>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col"><input type="checkbox" disabled checked></th>
                  <th scope="col">#</th>
                  <th scope="col">주문번호</th>
                  <th scope="col">신청일</th>
                  <th scope="col">캠퍼스</th>
                  <th scope="col">아이디</th>
                  <th scope="col">이름</th>
                  <th scope="col">상품명</th>
                  <th scope="col">기간</th>
                  <th scope="col">과정</th>
                  <th scope="col">결제방법</th>
                  <th scope="col">금액</th>
                  <th scope="col">상태</th>
                  <th scope="col">비고</th>
                </tr>
              </thead>
              <tbody>
              <tr>
                <th scope="col"><input type="checkbox" disabled checked></th>
                <th scope="col">#</th>
                <th scope="col">123456</th>
                <th scope="col">22-01-01</th>
                <th scope="col">신정</th>
                <th scope="col">kimdm22</th>
                <th scope="col">김대만</th>
                <th scope="col">{{ selProduct.name }}</th>
                <th scope="col">1</th>
                <th scope="col">K</th>
                <th scope="col">가상계좌</th>
                <th scope="col">{{ selProduct.price }}원</th>
                <th scope="col">입금대기</th>
                <th scope="col"><button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#buyProductModal" v-on:click="selProduct=record">주문하기</button>
<button class="btn btn-danger" data-toggle="modal" data-target=".bd-example-modal-t">주문하기21</button>
<!-- Large modal -->

<div class="modal fade bd-example-modal-t" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
  >
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">결제요청</h5>

      </div>
      <div class="modal-body">
        <table class="table">
            <tbody>
              <tr>
                <td class="th_bg">신청일</td>
                <td>22-01-28</td>
                <td class="th_bg">캠퍼스</td>
                <td>
                  신정
                </td>
              </tr>
              <tr>
                <td class="th_bg">이름</td>
                <td>유란희</td>
                <td class="th_bg">아이디</td>
                <td>
                  dibdfew
                </td>
              </tr>
              <tr>
                <td class="th_bg">담당교사</td>
                <td>Jenny</td>
                <td class="th_bg">학교아이디</td>
                <td>
                  at493
                </td>
              </tr>
              <tr>
                <td class="th_bg">현재레벨</td>
                <td>MyUse6</td>
                <td class="th_bg">변경레벨</td>
                <td>
                  MyUse7
                </td>
              </tr>
              <tr>
                <td class="th_bg">처리상태</td>
                <td><div class="input-group mb-12">
                    <div class="input-group-prepend">
                      <select class="custom-select flex_center" id="inputGroupSelect01">
                        <option selected>변경완료</option>
                        <option value="1">신청</option>
                        <option value="2">취소</option>
                      </select>
                    </div>
                  </div></td>
                <td class="th_bg">처리일</td>
                <td>
                  자동입력
                </td>
              </tr>

            </tbody>
          </table>
      </div>
      <div class="modal-footer flex_center">
        <button type="button" class="btn btn-primary" @click="doSend()">등록</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">닫기</button>

      </div>
    </div>
  </div>
</div>


                </th>



              </tr>
</tbody>


              <tbody>
                <tr v-for="record in records" v-bind:key="record.id">
                  <td><input type="checkbox"></td>
                  <th scope="row">{{ record.id }}</th>
                  <td>12345</td>
                  <td>2222</td>
                  <td>{{ record.name }}</td>
                  <td>{{ record.steps }}1</td>
                  <td>{{ record.price }}</td>
                  <td>1</td>
                  <td>338,000</td>
                  <td>상시</td>
                  <td>
                    <div class="input-group mb-12">
                      <div class="input-group-prepend">
                        <select class="custom-select flex_center" id="inputGroupSelect01">
                          <option selected>검색값 선택</option>
                          <option value="1">사용</option>
                          <option value="2">미사용</option>
                        </select>
                      </div>
                    </div>
                  </td>
                  <td><button class="btn btn-warning btn-sm">수정</button> <button class="btn btn-danger btn-sm">삭제</button>
                  </td>
                </tr>
              </tbody>
            </table>


            <table class="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">상품명</th>
                  <th scope="col">금액</th>
                  <th scope="col">주문</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="record in products" v-bind:key="record.id">
                  <th scope="row">{{ record.id }}</th>
                  <td>{{ record.name }}</td>
                  <td>{{ record.price }}</td>
                  <td><button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#buyProductModal" v-on:click="selProduct=record">주문하기</button></td>
                </tr>
              </tbody>
            </table>



                    <div class="modal fade" tabindex="-1" id="buyProductModal" data-bs-backdrop="false">
              <div class="modal-dialog" >
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">ID 결제하기</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                        <strong>학생명</strong>
                      <select v-model="selStudent" class="form-control">
                        <option v-for="student in students" v-bind:key="student.id" :value="student">{{ student.name }}({{student.username}})</option>
                      </select>
                      <strong>회원정보</strong>
                        <table class="table">
              <tbody>
                <tr>
                  <th scope="row">학습자</th>
                  <td>{{ selStudent.name }}</td>
                  <th scope="row">학습유형</th>
                  <td>{{ selProduct.product }}</td>
                  <th scope="row">학습레벨</th>
                  <td>설정 필요</td>
                </tr>
              </tbody>
            </table>
            <strong>상품정보</strong>
                        <table class="table">
              <tbody>
                <tr>
                  <th scope="row">상품명</th>
                  <td>{{ selProduct.name }}</td>
                  <th scope="row">금액</th>
                  <td>{{ selProduct.price }}원</td>
                </tr>
                <tr>
                  <th scope="row">기간</th>
                  <td>{{ selProduct.period }}개월</td>
                  <th scope="row">비고</th>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <strong>결제방법</strong>
                        <table class="table">
              <tbody>
                <tr>
                  <th scope="row">결제방법</th>
                  <td>    <select v-model="payMethod" class="form-control">
                  <option disabled value="">결제방식을 선택해 주세요</option>
                  <option value="CARD_ONPG">온라인 신용카드(문자전송)</option>
                  <option value="CARD_OFFPG">오프라인 신용카드</option>
                  <option value="CARD_ONPG">현금(자동세팅 불가)</option>
                </select></td>
                </tr>
              </tbody>
            </table>

                 <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" v-on:click="createSubscription()" :class="{'disabled': !Object.keys(selProduct).length}">생성</button>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                  </div>

                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>










  <div class="home">

    <h1 class="mt-4">ID1 주문</h1>

                        <ol class="breadcrumb mb-4">
                            <li class="breadcrumb-item active">ID 상품을 주문할 수 있습니다 </li>
                        </ol>



  </div>
  <!--

    ID/부가서비스
              <table class="table">
                  <tbody>
                    <tr>
                      <td class="th_bg">상품코드</td>
                      <td>자동생성</td>
                      <td class="th_bg">사용여부</td>
                      <td>
                        <div class="input-group mb-12">
                          <div class="input-group-prepend">
                            <select class="custom-select flex_center" id="inputGroupSelect01">
                              <option selected>선택</option>
                              <option value="1">사용</option>
                              <option value="2">미사용</option>
                            </select>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg" >상품 </td>
                        <td colspan="3"> 아이디 상품
                    </td>
                    </tr>
                    <tr>
                      <td class="th_bg" >메모 </td>
                        <td colspan="3"> 너무 많아....
                    </td>
                    </tr>
                    <tr>
                      <td class="th_bg">정상가</td>
                      <td>59,000</td>
                      <td class="th_bg">판매가</td>
                      <td>
                        69,000
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">상품구분</td>
                      <td>
                        <div class="input-group mb-12">
                          <div class="input-group-prepend">
                            <select class="custom-select flex_center" id="inputGroupSelect01">
                              <option selected>ID</option>
                              <option value="1">부가학습</option>
                              <option value="2">교재</option>
                            </select>
                          </div>
                        </div>

                      </td>
                      <td class="th_bg">반품(환불)</td>
                      <td>
                        <div class="input-group mb-12">
                          <div class="input-group-prepend">
                            <select class="custom-select flex_center" id="inputGroupSelect01">
                              <option selected>선택</option>
                              <option value="1">사용</option>
                              <option value="2">미사용</option>
                            </select>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">학습유형</td>
                      <td>  <div class="input-group mb-12">
                          <div class="input-group-prepend">
                            <select class="custom-select flex_center" id="inputGroupSelect01">
                              <option selected>MYUSE</option>
                              <option value="1">MYPATH</option>
                              <option value="2">부가학습</option>
                            </select>
                          </div>
                        </div></td>
                      <td class="th_bg">학습기간</td>
                      <td>
                        12개월
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">북클럽</td>
                      <td>  <div class="input-group mb-12">
                          <div class="input-group-prepend">
                            <select class="custom-select flex_center" id="inputGroupSelect01">
                              <option selected>사용</option>
                              <option value="1">사용</option>
                              <option value="2">미사용</option>
                            </select>
                          </div>
                        </div></td>
                      <td class="th_bg">보카조아</td>
                      <td>  <div class="input-group mb-12">
                          <div class="input-group-prepend">
                            <select class="custom-select flex_center" id="inputGroupSelect01">
                              <option selected>사용</option>
                              <option value="1">사용</option>
                              <option value="2">미사용</option>
                            </select>
                          </div>
                        </div></td>
                    </tr>
                    <tr>
                      <td class="th_bg">진열</td>
                      <td>  <div class="input-group mb-12">
                          <div class="input-group-prepend">
                            <select class="custom-select flex_center" id="inputGroupSelect01">
                              <option selected>기간</option>
                              <option value="1">상시</option>
                              <option value="2">1년</option>
                            </select>
                          </div>
                        </div></td>

                      <td class="th_bg" colspan="3">
                        <div class="input-group mb-12">
                          <div class="input-group-prepend">
                        <input Type="date" />~<input Type="date" />
                      </div></div></td>
                    </tr>
                  </tbody>
                </table>

                -->
</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import axios from "axios";
export default {
  name: 'Home',
  components: {
    Tree
  },
  mounted(){
    this.fetchProducts();
    this.fetchStudents();
  },
  methods: {
    fetchStudents(){
      axios.get('/students').then((response) => {
                  if(response.data.error){
                                        $.notify({
                    // options
                    message: '데이터를 조회할 수 없습니다. ' + response.data.error
                    }, {
                    // settings
                    type: 'danger',
                    z_index: 9999
                    });
                  } else {
                    this.students = response.data.result;
                  }


                })
    },
    getSubscriptions(){
            axios.get('/subscriptions?student=' + this.selStudent.id).then((response) => {
                  if(response.data.error){
                                        $.notify({
                    // options
                    message: '데이터를 조회할 수 없습니다. ' + response.data.error
                    }, {
                    // settings
                    type: 'danger',
                    z_index: 9999
                    });
                  } else {
                    this.selStudent.subscriptions = response.data.result;
                  }


                })
    },
    fetchProducts(){
                  axios.get('/products').then((response) => {
                  if(response.data.error){
                                        $.notify({
                    // options
                    message: '데이터를 조회할 수 없습니다. ' + response.data.error
                    }, {
                    // settings
                    type: 'danger',
                    z_index: 9999
                    });
                  } else {
                    this.products = response.data.result;
                  }


                })
    },
    createSubscription(){
      axios.post('/subscriptions', {
        'student': this.selStudent.id,
        'product': this.selProduct.id,
        'paymentMethod': this.payMethod,
        "subject":""
      }).then((response) => {
      if(response.data.error){
                            $.notify({
        // options
        message: 'ID 추가 실패: ' + response.data.error
        }, {
        // settings
        type: 'danger',
        z_index: 9999
        });
      } else {
        this.$router.push('/subscriptions')

      }


    })
    }
  },
  data(){
    return {
      students: [],
      selStudent: {},
      tabActive: 'subscription',
      payMethod: "",
      selProduct: {},
      products: {}
    }
  }
}
</script>
